<template>
<div>
  <div class="horizontal">
    <div class="left">{{ item.heading }}</div>
    <div class="right">
      <table class="table-connection">
        <thead>
          <tr>
            <th>{{ item.heading }}名</th>
            <th>シェア</th>
            <th>掛取引の割合</th>
            <th>回収・支払の条件</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(stakeholder, index) in item.data.stakeholders">
            <th>{{ stakeholder.name }}<span class="note">{{ stakeholder.address }}</span></th>
            <td>{{ stakeholder.shareRate }}%</td>
            <td>{{ stakeholder.salesOnCreditRate }}%</td>
            <td>{{ stakeholder.closingAndPayment }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <expert-comment v-bind:item="item"
    v-if="isConsultationPlan"
    v-bind:groupIndex="groupIndex"
    v-bind:itemIndex="itemIndex"
    v-bind:isEditableComment="isEditableComment"></expert-comment>
</div>
</template>

<script>
import expertComment from '@/components/parts/ExpertComment'
export default {
  components: {
    'expert-comment': expertComment
  },
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex', 'isConsultationPlan', 'isEditableComment'],
  computed: {},
  mounted: function () {},
  methods: {},
  watch: {}
}
</script>
